import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import GenerateTokenType from 'app/utils/services/types/generateToken.type';

const generateTokenService = async (lang: string | null): Promise<GenerateTokenType> => {
  // if (lang === null) {
  //   const result = await httpClient.post<GenerateTokenType>('/api-web/v1/pub/generate_token');
  //
  //   return result;
  // } else {

  const result = await httpClient.post<GenerateTokenType>('/api-web/v1/pub/generate_token', null, {
    headers: { Language: lang },
  });

  return result;
  // }
};

export const useGenerateTokenService = () => {
  const {
    isLoading: isLoadingToken,
    data: dataToken,
    error: errorToken,
    mutate: tokenMutation,
  } = useMutation(['generateToken'], (lang: string) => generateTokenService(lang));

  return { isLoadingToken, dataToken, errorToken, tokenMutation };
};
